export default __webpack_public_path__ + "static/media/arrow-left.0739bd27.svg";